/* eslint-disable import/first, import/newline-after-import */

import 'components/resources/grid/grid';
import 'components/util/resource-action-buttons/resource-action-buttons';
import 'components/contributors/contributor-details/contributor-details';

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

// If split test fails, remove this and uncomment instances of this controller in other packs
import ResourcesGridController from 'components/resources/grid/grid-controller';
EezyStimulusApplication.register('resources-grid', ResourcesGridController);
// end split-test: iscroll_modal

import ThumbnailContribInfoController from 'components/resources/grid/contrib-info-controller';
EezyStimulusApplication.register('thumbnail-contributor-info', ThumbnailContribInfoController);

import(
  /* webpackChunkName: "ez-drop-down-controller" */
  /* webpackPreload: true */
  'components/resources/grid/contrib-info-controller'
).then((controller) => {
  EezyStimulusApplication.register('thumbnail-contributor-info', controller.default);
});

import VideoPreviewController from 'components/video/preview/video-preview-controller';
EezyStimulusApplication.register('video-preview', VideoPreviewController);
